/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : CREATE LABELS : STYLES --------------- ++++++++++ */
export default theme => ({
    createlabels: {
        maxWidth: pxToEm(432),
        '& .accent': {
            '& .accentitem': {
                display: 'block',
                opacity: 'inherit',
                marginBottom: pxToEm(5)
            }
        }

    }
});
